module.exports = __webpack_public_path__ + "static/BlockchainSmartcontracts-3bd51cb18c0a11fe51432ec8d2651294.png";